import type {
    CalendarSync as CalendarSyncFragment,
    TaskSync as TaskSyncFragment,
    UserEmailAddress as UserEmailAddressFragment,
    UserEmail as UserEmailFragment,
} from 'nutshell-graphql-types';

type MutationPayload = {
    readonly __typename: string;
    authUrl: string | null | undefined;
    newConnectionId: string | null | undefined;
    calendarSync?: CalendarSyncFragment | null | undefined;
    taskSync?: TaskSyncFragment | null | undefined;
    sendableEmailAddresses?: UserEmailAddressFragment | null | undefined;
    userEmail?: UserEmailFragment[] | null | undefined;
    emailAddresses?: UserEmailFragment[] | null | undefined;
};

// Remember!  Add the key here if you add another type of mutation
// @ts-expect-error
function sanitizePayload(mutationResult): MutationPayload | null | undefined {
    const data = mutationResult && mutationResult.data;

    if (!data) return null;

    if (data.setOffice365CalendarSyncIsEnabled !== undefined) {
        return data.setOffice365CalendarSyncIsEnabled;
    }

    if (data.setGoogleCalendarSyncIsEnabled !== undefined) {
        return data.setGoogleCalendarSyncIsEnabled;
    }

    if (data.setGoogleTaskSyncIsEnabled !== undefined) {
        return data.setGoogleTaskSyncIsEnabled;
    }

    if (data.setCalendarSyncImportIsEnabled !== undefined) {
        return data.setCalendarSyncImportIsEnabled;
    }

    if (data.setGoogleMailSendIsEnabled !== undefined) {
        return data.setGoogleMailSendIsEnabled;
    }

    if (data.setOffice365MailSendIsEnabled !== undefined) {
        return data.setOffice365MailSendIsEnabled;
    }

    if (data.setGoogleMailSyncIsEnabled !== undefined) {
        return data.setGoogleMailSyncIsEnabled;
    }

    if (data.setOffice365MailSyncIsEnabled !== undefined) {
        return data.setOffice365MailSyncIsEnabled;
    }

    if (data.setAircallIntegrationIsEnabledForInstance !== undefined) {
        return data.setAircallIntegrationIsEnabledForInstance;
    }

    if (data.setDialpadIntegrationIsEnabled !== undefined) {
        return data.setDialpadIntegrationIsEnabled;
    }

    if (data.setRingCentralIntegrationIsEnabled !== undefined) {
        return data.setRingCentralIntegrationIsEnabled;
    }
}

// Would love to give this argument stronger typing, but it causes all kinds of problems upstream
// with flow.
export function getAuthUrl(mutationResult: any): string | null | undefined {
    const payload = sanitizePayload(mutationResult);

    return payload && payload.authUrl;
}

export function getAuthResults(mutationResult: any): {
    authUrl: string | null | undefined;
    newConnectionId: string | null | undefined;
} {
    const payload = sanitizePayload(mutationResult);

    return {
        authUrl: payload && payload.authUrl,
        newConnectionId: payload && payload.newConnectionId,
    };
}

// Would love to give this argument stronger typing, but it causes all kinds of problems upstream
// with flow.
export function getCalendarSync(mutationResult: any): CalendarSyncFragment | null | undefined {
    const payload = sanitizePayload(mutationResult);

    return payload && payload.calendarSync;
}

// Would love to give this argument stronger typing, but it causes all kinds of problems upstream
// with flow.
export function getTaskSync(mutationResult: any): TaskSyncFragment | null | undefined {
    const payload = sanitizePayload(mutationResult);

    return payload && payload.taskSync;
}

// Would love to give this argument stronger typing, but it causes all kinds of problems upstream
// with flow.
export function getEmailAddresses(mutationResult: any): UserEmailFragment[] | null | undefined {
    const payload = sanitizePayload(mutationResult);

    return payload && payload.emailAddresses;
}
